import { render, staticRenderFns } from "./popup-layer.vue?vue&type=template&id=f406e4e2&scoped=true&"
import script from "./popup-layer.vue?vue&type=script&lang=js&"
export * from "./popup-layer.vue?vue&type=script&lang=js&"
import style0 from "./popup-layer.vue?vue&type=style&index=0&id=f406e4e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f406e4e2",
  null
  
)

export default component.exports